import React, { useState } from 'react';
import { DateRangePicker } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import 'moment/locale/ru'; // Импортируем русскую локаль
import "./css/style.css";
// Устанавливаем русскую локаль для moment.js
moment.locale('ru');

export default function DateInp({dates, setDates}) {
  const [focusedInput, setFocusedInput] = useState(null);

   // Функция для проверки, находится ли дата вне допустимого диапазона
   const isOutsideRange = (day) => {
    const today = moment().startOf('day');
    return day.isBefore(today, 'day');
  };

  return (
    <div>
      <DateRangePicker
        startDate={dates.startDate}
        startDateId="date_start"
        
        endDate={dates.endDate}
        endDateId="date_end"
        onDatesChange={({ startDate, endDate }) => setDates({ startDate, endDate })}
        focusedInput={focusedInput}
        onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
        isOutsideRange={isOutsideRange} // Устанавливаем функцию проверки диапазона
      
        displayFormat="DD.MM.YYYY"
        numberOfMonths={1}
        startDatePlaceholderText="DD.MM.YYYY" // Текст для placeholder начальной даты
        endDatePlaceholderText="DD.MM.YYYY" // Текст для placeholder конечной даты
       />
   
    </div>
  );
}
